import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import issueTypesService from "../../services/api/IssueTypes";
import SuccessMessages from "../../constants/SucessMessages.json";
import { isValNull } from "../../utils";

function handleError(err) {
  console.log("error in rider support actions:", err);
}

export const setIssueTypeList = (payload) => {
  return {
    type: ActionTypes.SET_ISSUE_TYPE_LIST,
    payload,
  };
};
export const setCurrentPageIssueType = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_ISSUE_TYPE,
    payload,
  };
};
export const setIssueArea = (payload) => {
  return {
    type: ActionTypes.SET_ISSUE_AREA,
    payload,
  };
};
export const setIssueTypeDetails = (payload) => {
  return {
    type: ActionTypes.SET_ISSUE_TYPE_DETAILS,
    payload,
  };
};
export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ISSUE_TYPE_ACTIVE_FILTERS,
    payload,
  };
};
export const getIssueTypeDetails = (issueId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await issueTypesService.getIssueDetail(issueId);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setIssueTypeDetails(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
export const getIssueArea = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await issueTypesService.getIssueArea();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setIssueArea(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getIssueTypeList =
  (pageNumber, activeFilters) => async (dispatch) => {
    try {
      let filterBody = {};
      const filterKeys = {
        issueName: "name",
        externalMappingName: "externalMappingName",
        enabled: "enabled",
        issueArea: "issueArea",
      };
      let activeFiltersObj = {};
      Object.keys(activeFilters).map((key, index) => {
        if (!isValNull(activeFilters[key])) {
          Object.assign(activeFiltersObj, { [key]: activeFilters[key] });
          if (key === "enabled") {
            Object.assign(filterBody, {
              [filterKeys[key]]:
                activeFilters[key] === "Yes" ? "true" : "false",
            });
          } else {
            Object.assign(filterBody, {
              [filterKeys[key]]: activeFilters[key],
            });
          }
        }
      });
      const body = {
        filters: filterBody,
        pageRequest: {
          page: pageNumber,
          pageSize: 20,
        },
      };
      dispatch(setLoader(true));
      let response = await issueTypesService.getIssueTypeList(body);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setIssueTypeList(response));
        dispatch(setCurrentPageIssueType(pageNumber));
        dispatch(setActiveFilters(activeFiltersObj));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
export const saveUpdateIssueType = (actionType, data) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    if (actionType !== "create") {
      data.id = Number(data.id);
    }
    let response = await issueTypesService.saveUpdateIssueType(
      actionType,
      data
    );
    dispatch(setLoader(false));
    if (response) {
      // dispatch(getIssueTypeList(1, {}));
      dispatch(
        setStatus({
          type: "success",
          message:
            actionType === "create"
              ? SuccessMessages.CREATION_SUCCESS
              : SuccessMessages.UPDATION_SUCCESS,
        })
      );
      dispatch(setIssueTypeDetails(data));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
